import * as z from 'zod';

import { emailSchema } from '@/_schemas/generic';

export const signupFormSchema = z
  .object({
    name: z.string().trim().min(1, 'Name is required'),
    email: emailSchema(false),
    password: z.string().min(8, 'Password must be at least 8 characters'),
    password_confirmation: z.string().min(1, 'Please confirm your password'),
  })
  .refine((data) => data.password === data.password_confirmation, {
    message: 'Passwords do not match',
    path: ['password_confirmation'],
  });

export type SignupFormSchema = z.infer<typeof signupFormSchema>;

export const SIGNUP_FORM_DEFAULT_VALUES: SignupFormSchema = {
  name: '',
  email: '',
  password: '',
  password_confirmation: '',
};
